import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1.25, 1.25, 2.25),
    backgroundColor: theme.palette.modal.light,
    maxWidth: '100%',
    overflowX: 'auto',
  },

  resultContainer: {
    display: 'flex',
    flex: 1,
    minWidth: '33%',
    flexDirection: 'column',
    alignItems: 'center',
    height: theme.spacing(10.25),
    justifyContent: 'space-between',
  },
}));
